import React from 'react';
import { Card, CardContent, CardActionArea, Typography, IconButton, Grid } from '@mui/material';
import { useCode } from '../../../contexts/Code';

const Activities = ({ children }) => {
  const {code} = useCode();

  if (!code) return null;

  return (
    <Card sx={{ marginTop: 2 }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {code == 45 ? 'Activities' : 'Actividades'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {code == 45
            ? 'The more activities you do, the more points you will earn!'
            : '¡Mientras más actividades hagas, ganarás más puntos!'}
        </Typography>
      </CardContent>
      {children}
    </Card>
  );
};

export default Activities;